import { render } from "./img.vue?vue&type=template&id=8bd44e1c&scoped=true"
import script from "./img.vue?vue&type=script&lang=js"
export * from "./img.vue?vue&type=script&lang=js"

import "./img.vue?vue&type=style&index=0&id=8bd44e1c&lang=css"
import "./img.vue?vue&type=style&index=1&id=8bd44e1c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bd44e1c"]])

export default __exports__